import useAuth from './useAuth';
import useDynamicConfig from './useDynamicConfig';
import useUserTopRole from './useUserTopRole';

const useUserTopRoleInfo = () => {
  const { user } = useAuth();
  const { userTopRoleId } = useUserTopRole(user?.id);
  const { SYSTEM_ROLES, COMPANY_ROLES, PROPERTY_ROLES } = useDynamicConfig();

  const isSystemRole = !!userTopRoleId && SYSTEM_ROLES?.includes(userTopRoleId);

  const isCompanyRole = !!userTopRoleId && COMPANY_ROLES?.includes(userTopRoleId);

  const isPropertyRole = !!userTopRoleId && PROPERTY_ROLES?.includes(userTopRoleId);

  return {
    userTopRoleId,
    isSystemRole,
    isCompanyRole,
    isPropertyRole
  };
};

export default useUserTopRoleInfo;
